<template>
  <v-col style="max-width: 900px">
    <h1 class="primary--text">
      {{ $t('documentation.titles.signatures.title') }}
    </h1>
    <h2 class="primary--text">
      {{ $t('documentation.texts.signatures.signatureDetail.title') }}
    </h2>
    <p>{{ $t('documentation.texts.signatures.signatureDetail.paragraph1') }}</p>
    <v-img style="width: 100%; max-width: 900px" contain :src="pic1Name" />
    <p>{{ $t('documentation.texts.signatures.signatureDetail.paragraph2') }}</p>
    <p>{{ $t('documentation.texts.signatures.signatureDetail.paragraph3') }}</p>
    <v-img
      style="width: 100%; max-width: 600px"
      contain
      :src="picJointDetail"
    />
  </v-col>
</template>

<script>
export default {
  computed: {
    pic1Name() {
      return require('@/assets/documentation/signatures/' +
        this.$t(
          'documentation.texts.signatures.signatureDetail.picSignatureDetail'
        ) +
        '.png')
    },
    picJointDetail() {
      return require('@/assets/documentation/signatures/' +
        this.$t(
          'documentation.texts.signatures.signatureDetail.picJointDetail'
        ) +
        '.png')
    },
  },
  methods: {},
}
</script>

<style>
.custom-link {
  transition: 0.3s;
  cursor: pointer;
}
.custom-link:hover {
  text-decoration: underline;
}
</style>
